import { camelCaseKeys } from "src/utility/utilityFunctions";

import { createSlice } from "@reduxjs/toolkit";

import { axiosGet } from "../../../api/axiosCalls";
import { setError } from "../errorSlice";

const initialState = {
  isLoading: false,
  programTypes: [],
  error: null,
};

const loadingFailed = (state, action) => {
  const { error } = action.payload;
  state.isLoading = false;
  state.error = error;
};

const programTypeSlice = createSlice({
  name: "programTypes",
  initialState,
  reducers: {
    setIsLoading(state) {
      state.isLoading = true;
    },
    getProgramTypesSuccess(state, action) {
      const { types } = action.payload;
      state.programTypes = types.map((pt) => ({
        ...camelCaseKeys(pt),
        name: pt.description,
      }));
      state.isLoading = false;
      state.error = null;
    },
    setFailure: loadingFailed,
  },
});

export const { setIsLoading, getProgramTypesSuccess, setFailure } =
  programTypeSlice.actions;

export default programTypeSlice.reducer;

export const getProgramTypes = () => async (dispatch) => {
  try {
    dispatch(setIsLoading());
    const response = await axiosGet("/api/program-types");
    if (response.error) {
      throw response.error;
    }
    dispatch(getProgramTypesSuccess({ types: response.data }));
  } catch (err) {
    dispatch(setFailure({ error: err.toString() }));
    dispatch(setError({ error: err.toString(), source: "Program Types" }));
  }
};
